var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineCorner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{opacity:0.3;mix-blend-mode:multiply;}.c{fill:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("image", {
    className: "b",
    width: 164,
    height: 88,
    xlinkHref: "elemento121.png"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 45.72,
    y: 55.97,
    width: 29.62,
    height: 14.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 16.3,
    y: 55.97,
    width: 15.63,
    height: 14.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 90.51,
    y: 55.97,
    width: 64.52,
    height: 14.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 140.17,
    y: 7.3,
    width: 14.86,
    height: 63.24
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineCorner);
export default __webpack_public_path__ + "static/media/lineCorner.1b35d66f87f11ed255a8e3a82fce0126.svg";
export { ForwardRef as ReactComponent };